import { colorPaletteLight, colorPaletteDark } from "./color-palette";
import light from "./light";
import dark from "./dark";
const black = "#000";
export function createTheme(_ref) {
  let {
    base = "light",
    data = {},
    colors
  } = _ref;
  const baseTheme = base === "light" ? light : dark;
  const getColor = name => {
    if (colors && colors[name]) {
      return base === "light" ? colorPaletteLight(colors[name]) : colorPaletteDark(colors[name], dark.colors.bg.body);
    }
    return baseTheme.colors[name];
  };
  const primary = getColor("primary");
  const secondary = getColor("secondary");
  const positive = getColor("positive");
  const negative = getColor("negative");
  const warning = getColor("warning");
  const info = getColor("info");
  return {
    ...baseTheme,
    data,
    colors: {
      ...baseTheme.colors,
      primary,
      secondary,
      positive,
      negative,
      warning,
      info,
      dark: {
        ...baseTheme.colors.dark,
        bg: base === "light" ? primary[9] : black
      }
    }
  };
}